<template>
  <el-cascader clearable :props="{ multiple: multiple }" style="width: 400px" v-model="value" :options="options"
    @change="changeRegion"></el-cascader>
</template>
<script>
import { CodeToText, TextToCode, regionData, regionDataPlus } from "element-china-area-data";
export default {
  model: {
    prop: "content",
    event: "change",
  },
  props: {
    content: [Number, Array],
    multiple: {
      type: Boolean,
      default: true
    },
    createId: {
      type: [Number, String]
    }
  },
  data() {
    return {
      options: [],
    };
  },
  created() {
    this.getData()
  },
  methods: {
    changeRegion(e) {
      this.$emit("change", e);
    },
    getData() {
      this.$httpRequest
        .get(
          "/api/agentManage/getAgentInfo?id=" +
         (this.createId || this.$store.state.user.info.createId)
        )
        .then((res) => {
          const data = res.data.obj;
          const ownPCCs = data.ownArea.split(";");
          this.options = [];
          ownPCCs.forEach((i) => {
            const pcc = i.split("-");
            let province = this.options.find((p) => p.label == pcc[0]);
            if (!province) {
              province = { label: pcc[0], value: TextToCode[pcc[0]].code };
              this.options.push(province);
            }
            if (pcc.length >= 2) {
              if (!province.children) {
                province.children = [];
              }
              let city = province.children.find((c) => c.label == pcc[1]);
              if (!city) {
                city = { label: pcc[1], value: TextToCode[pcc[0]][pcc[1]].code };
                province.children.push(city);
              }

              if (pcc.length >= 3) {
                if (!city.children) {
                  city.children = [];
                }
                let area = city.children.find((c) => c.label == pcc[2]);
                if (!area) {
                  area = {
                    label: pcc[2],
                    value: TextToCode[pcc[0]][pcc[1]][pcc[2]].code,
                  };
                  city.children.push(area);
                }
                if (pcc.length == 4) {
                  if (!area.children) {
                    area.children = [];
                  }
                  const street = area.children.find((c) => c.label == pcc[3]);
                  if (!street) {
                    area.children.push({ label: pcc[3], value: pcc[3] });
                  }
                }
              }
            }
          });
          //this.value = this.content;
        })
        .catch((e) => { });
    }
  },
  computed: {
    value: {
      get() {
        return this.content
      },
      set(newValue) {
        //this.modelValue = newValue
        this.$emit('input', newValue)
      }
    }
  },
  watch:{
    createId(){
      if(this.createId){
        this.getData()
      }
      
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/plugin/common-region.vue